/**
 * gat-flower-variant-handler.js
 * Converts 7g / 14g / 28g → multiple units of 3.5g
 * Disables sizes that need more 3.5g stock than is available
 */

(function () {
  'use strict';

  const MULTIPLIERS = window.GAT_FLOWER_MULTIPLIERS || {
    '3.5 grams': 1,
    '7 grams': 2,
    '14 grams': 4,
    '28 grams': 8
  };

  function getSelectedWeight() {
    let el = document.querySelector('input[name="Weight"]:checked');
    if (el) return el.value.trim();

    el = document.querySelector('input[type="radio"][name*="Weight"]:checked');
    if (el) return el.value.trim();

    return null;
  }

  function getAvailableStock(callback) {
    const inventory = parseInt(window.GAT_FLOWER_INVENTORY, 10) || 0;
    const baseId = Number(window.GAT_FLOWER_BASE_VARIANT_ID);

    fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === baseId) inCart += item.quantity;
        });
        callback(Math.max(0, inventory - inCart));
      })
      .catch(function () {
        callback(inventory);
      });
  }

  function updateWeightAvailability(available) {
    var inputs = document.querySelectorAll('input[name="Weight"]');
    var selected = getSelectedWeight();
    var selectedStillValid = true;

    inputs.forEach(function (input) {
      var weight = input.value.trim();
      var needed = MULTIPLIERS[weight];
      if (!needed) return;

      var disabled = available < needed;
      input.disabled = disabled;
      input.classList.toggle('option-disabled', disabled);

      var label = document.querySelector('label[for="' + input.id + '"]');
      if (label) {
        label.classList.remove('gat-weight-disabled');
        label.style.opacity = '';
        label.style.pointerEvents = '';
        label.style.textDecoration = '';
      }

      if (disabled && weight === selected) selectedStillValid = false;
    });

    if (!selectedStillValid) {
      var baseInput = document.querySelector('input[name="Weight"][value="3.5 grams"]');
      if (baseInput && !baseInput.disabled) {
        baseInput.checked = true;
        baseInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function refreshAvailability() {
    getAvailableStock(updateWeightAvailability);
  }

  function syncCartUi(cart) {
    if (cart.item_count === undefined) return;

    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) {
        el.innerHTML = '(' + cart.item_count + ')';
      } else {
        el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
      }
    });

    if (document.querySelector('header-total-price') && typeof document.querySelector('header-total-price').updateTotal === 'function') {
      document.querySelector('header-total-price').updateTotal(cart);
    }

    var bar = document.querySelector('free-ship-progress-bar');
    if (bar && typeof bar.init === 'function') {
      bar.init(cart.items_subtotal_price);
    }
  }

  function replaceMinicartForm(sectionHtml) {
    if (!sectionHtml) return;
    var current = document.getElementById('minicart-form');
    if (!current) return;
    var html = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var neu = html.querySelector('#minicart-form');
    if (neu) current.innerHTML = neu.innerHTML;
  }

  function getCartNotification() {
    return document.querySelector('cart-notification');
  }

  function openMinicart() {
    var note = getCartNotification();
    if (!note || typeof note.open !== 'function') return;
    var wrapper = document.querySelector('#minicart_wrapper .minicart__wrapper');
    if (wrapper && wrapper.classList.contains('open')) return;
    note.open();
  }

  function handleAddToCart(e) {
    if (!window.GAT_FLOWER_BASE_VARIANT_ID) return;

    var weight = getSelectedWeight();
    if (!weight || !MULTIPLIERS[weight]) return;

    var multiplier = MULTIPLIERS[weight];
    var qtyInput = document.querySelector('input[name="quantity"], input[name="qty"], .quantity__input, [data-quantity]');
    var currentQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var finalQty = currentQty * multiplier;

    e.preventDefault();
    e.stopImmediatePropagation();

    getAvailableStock(function (available) {
      if (finalQty > available) {
        alert('Only ' + available + ' x 3.5g left in stock.');
        refreshAvailability();
        return;
      }

      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(window.GAT_FLOWER_BASE_VARIANT_ID),
          quantity: finalQty,
          sections: ['minicart-form'],
          sections_url: window.location.pathname
        })
      })
      .then(function (res) { return res.text(); })
      .then(function (state) {
        var parsedState = JSON.parse(state);
        if (parsedState.sections && parsedState.sections['minicart-form']) {
          replaceMinicartForm(parsedState.sections['minicart-form']);
        }

        var note = getCartNotification();
        if (note && typeof note.cartAction === 'function') note.cartAction();

        return fetch('/cart.json').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        syncCartUi(cart);
        openMinicart();
        refreshAvailability();
        if (typeof BlsLazyloadImg !== 'undefined') BlsLazyloadImg.init();
      })
      .catch(function (err) {
        console.error('GAT Flower error:', err);
      });
    });
  }

  function init() {
    if (!window.GAT_FLOWER_BASE_VARIANT_ID) return;

    var buttons = document.querySelectorAll(
      'button[name="add"], ' +
      'button[type="submit"][name="add"], ' +
      '.product-form__submit, ' +
      '.add-to-cart, ' +
      '[data-add-to-cart]'
    );

    buttons.forEach(function (btn) {
      btn.removeEventListener('click', handleAddToCart, true);
      btn.addEventListener('click', handleAddToCart, true);
    });

    refreshAvailability();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();